import {IconProps} from '../icon-props-interface';
import '../icons.scss';

export const IconCircleRestockable = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 20 20"
            >
            <path
                fill={color}
                fillRule="evenodd"
                d="M9.633 12.833c.053-.29.133-.575.238-.85H7.073a.208.208 0 00-.21.213v.425c0 .132.08.212.21.212h2.56zM4.545 1.786h10.018c.913 0 1.67.77 1.67 1.7V9.32a4.773 4.773 0 00-.835-.276V3.486c0-.452-.391-.85-.835-.85H4.545a.848.848 0 00-.835.85v10.197c0 .478.365.85.835.85h5.084c.052.29.13.575.235.85h-5.32c-.938 0-1.669-.744-1.669-1.7V3.486c0-.93.73-1.7 1.67-1.7zm7.931 7.509V6.737l.913 1.169c.13.159.392.239.6.08.157-.16.209-.426.052-.612l-1.67-2.124c-.156-.186-.495-.186-.652 0l-1.67 2.124a.461.461 0 00.079.611.41.41 0 00.574-.08l.94-1.168v2.579c0 .133.077.212.208.212h.147c.156-.086.315-.164.479-.233zM6.632 6.737l-.94 1.169a.41.41 0 01-.573.08.461.461 0 01-.079-.612L6.71 5.25c.157-.186.496-.186.652 0l1.67 2.124c.157.186.105.452-.052.611-.209.16-.47.08-.6-.08l-.913-1.168v2.579a.208.208 0 01-.209.212h-.417c-.13 0-.21-.08-.21-.212V6.737z"
                clipRule="evenodd"
            ></path>
            <g clipPath="url(#clip0_76_48)">
                <path
                fill={color}
                d="M14.513 10.261a3.578 3.578 0 110 7.157 3.578 3.578 0 010-7.157zm0 7.982a4.404 4.404 0 100-8.808 4.404 4.404 0 000 8.808zm1.944-5.212a.413.413 0 00-.583-.583l-1.91 1.91-.808-.81a.413.413 0 00-.583.583l1.1 1.102a.411.411 0 00.584 0l2.2-2.202z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_76_48">
                <path
                    fill="#fff"
                    d="M0 0H9V9H0z"
                    transform="translate(10.125 9.214)"
                ></path>
                </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconCircleRestockable;
